import { render, staticRenderFns } from "./VxPlaceSearch.vue?vue&type=template&id=02f8f1ba&scoped=true"
import script from "./VxPlaceSearch.vue?vue&type=script&lang=js"
export * from "./VxPlaceSearch.vue?vue&type=script&lang=js"
import style0 from "./VxPlaceSearch.vue?vue&type=style&index=0&id=02f8f1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f8f1ba",
  null
  
)

export default component.exports